import { Injectable, inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { Observable, map } from "rxjs";
import { PermissionLoaderService } from "../shared/services/permission-loader.service";
import { PermissionService } from "../shared/services/permission.service";

@Injectable({
  providedIn: "root",
})
export class AdministrationGuardService {
  constructor(
    private permissionService: PermissionService,
    private permissionLoaderService: PermissionLoaderService,
    private router: Router
  ) {}

  /**
   * Determines whether the administration section can be activated, once the permissions stored in
   * the session are up to date: this guard runs alongside AuthGuard, not after it, so it can't rely
   * on AuthGuard having loaded them.
   * @return Emits true if the user's role grants access to it, or a UrlTree redirecting to /landing otherwise
   */
  canActivate(): Observable<boolean | UrlTree> {
    return this.permissionLoaderService.loadPermissions().pipe(
      map(() => {
        if (this.permissionService.canAccessAdministration) {
          return true;
        } else {
          return this.router.createUrlTree(["/landing"]);
        }
      })
    );
  }
}

export const AdministrationGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  return inject(AdministrationGuardService).canActivate();
};
